import React from 'react'
import { Drawer } from 'antd'
import EditCategoryForm from './EditCategoryForm'
import { useDispatch } from 'react-redux'
import { questionActions } from '../../../../../../store/slices/question.slice'

const EditCategoryDrawer = () => {
    const dispatch = useDispatch()

    const handleClose = () => dispatch(questionActions.setEditingCategoryId(null))

    return (
        <Drawer title='Edit category' autoFocus onClose={handleClose} open width={560} destroyOnClose>
            <EditCategoryForm onSuccess={handleClose} />
        </Drawer>
    )
}

export default EditCategoryDrawer
